import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { DatePipe } from '@angular/common';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/AppRenewal/appRenewal.html'
})

export class AppRenewalComponent implements OnInit {

    userDetail: any;
    public constants: Constants;
    public appRenewals: any[] = [];

    public customers: any[] = [];

    public users: any[] = [];
    //public applicationReleaseLogs : any[] = [];

    public addAppRenewalData: any = {
        //addApplicationCustomerId: "",
        addAppRenewalStatus:true
    };

   
   //public filterCustomerStatus: any = "";
   public filterUserStatus: any = "";

    public EditAppRenewalData: any = {
       // editApplicationCustomerId: ""
    };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsAppRenewalName: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
        this.filterUserStatus = this.constants.enumUserStatus["Active"];
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        
        this.getAppRenewals();
        // this.getCustomers();
        this.getUsers();
    }

    ExportItems() {

    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }

    public addAppRenewalFormLoad() {
        $('#btnaddAppRenewalForm').trigger('click');

        this.addAppRenewalData = {
            //addApplicationCustomerId: '',
            addAppRenewalStatus:true
        };
    }
    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public getUsers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetAllUsers', {
            "IsActive": this.filterUserStatus
        }).subscribe(
            data => {
                this.users = data["Users"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }

    public getAppRenewals() {
        debugger
        this.showLoader = true;

        this._httpService.ajaxPost('AppRenewal/GetAppRenewal', null
        ).subscribe(
            data => {
                this.appRenewals = data["AppRenewal"];
               // var datePipe = new DatePipe();
                // this.applications.forEach(element => {
                //     element.ReleaseDate = this._datepipe.transform(element.ReleaseDate, 'dd/MM/yyyy');
                // });

            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/AppRenewal/appRenewal.component.ts
 **/